import { useEffect, useCallback, useMemo } from "react";
import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import { InteractionStatus } from "@azure/msal-browser";

const MOCK_AUTH = import.meta.env.VITE_PLAYWRIGHT_TESTING_MODE === "true";

export function useAuth() {
  const { instance, inProgress } = useMsal();

  const login = useCallback(async () => {
    await instance.loginRedirect({
      scopes: ["User.Read"],
      redirectUri: globalThis.location.origin,
    });
  }, [instance]);

  const isAuthenticated = useIsAuthenticated();

  const user = instance.getAllAccounts()[0];

  useEffect(() => {
    if (
      !isAuthenticated &&
      inProgress === InteractionStatus.None &&
      !MOCK_AUTH
    ) {
      login();
    }
  }, [isAuthenticated, inProgress, login]);

  function logout() {
    instance.logoutRedirect({
      account: user,
    });
  }

  const userInfo = useMemo(() => {
    let userInfo;
    if (MOCK_AUTH) {
      userInfo = { name: "Test User", email: "test.user@bdo.co.uk" };
    } else if (user) {
      userInfo = { name: user.name, email: user.username.toLowerCase() };
    } else {
      userInfo = undefined;
    }
    return userInfo;
  }, [user]);

  return {
    isAuthenticated: MOCK_AUTH || isAuthenticated,
    user: userInfo,
    logout,
  };
}
